/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ side: NonNullable<unknown>, area: NonNullable<unknown> }} Profile_Pain_SidedInputs */

const en_us2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.side} ${i?.area}`)
};

const pt_br2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area} ${i?.side}`)
};

const es_419_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area} ${i?.side}`)
};

const pt_pt2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area} ${i?.side}`)
};

const fr_fr2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area}, côté ${i?.side}`)
};

const de_de2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area} ${i?.side}`)
};

const it_it2_profile_pain_sided = /** @type {(inputs: Profile_Pain_SidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.area}, lato ${i?.side}`)
};

/**
* | output |
* | --- |
* | "{side} {area}" |
*
* @param {Profile_Pain_SidedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_sided = /** @type {((inputs: Profile_Pain_SidedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_SidedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_sided(inputs)
	if (locale === "es-419") return es_419_profile_pain_sided(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_sided(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_sided(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_sided(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_sided(inputs)
	return en_us2_profile_pain_sided(inputs)
});
export { profile_pain_sided as "profile.pain_sided" }